/* =====================================================================
   LIVEA — interactions (carrousel d'avis, CTA vers le selecteur de quantite)
   Les accordeons utilisent <details>/<summary> natifs : aucun JS requis.
   ===================================================================== */
(function () {
  'use strict';
  if (window.__liveaInit) return;
  window.__liveaInit = true;

  function all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* ------------------------------------------- defilement anime maison */
  function animateTo(top, done) {
    top = Math.max(0, Math.round(top));
    var start = window.pageYOffset || document.documentElement.scrollTop;
    var delta = top - start;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || Math.abs(delta) < 2) { window.scrollTo(0, top); if (done) done(); return; }
    var dur = Math.min(900, Math.max(300, Math.abs(delta) / 4)), t0 = null, fin = false;
    function end() { if (fin) return; fin = true; window.scrollTo(0, top); if (done) done(); }
    function step(ts) {
      if (fin) return;
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      window.scrollTo(0, start + delta * e);
      if (p < 1) requestAnimationFrame(step); else end();
    }
    if (window.requestAnimationFrame) requestAnimationFrame(step); else end();
    setTimeout(end, dur + 300);   // filet de securite si rAF ne tourne pas
  }

  /* --------------------------------- cible : selecteur de quantite natif */
  var QTY = ['.quantity-breaks-container', '.product-form__quantity', 'quantity-input',
             '.product-form__buttons'];

  function qtyTarget() {
    for (var i = 0; i < QTY.length; i++) {
      var el = document.querySelector(QTY[i]);
      if (el) return el;
    }
    return null;
  }

  function tagTarget() {
    var t = qtyTarget();
    if (t && !document.getElementById('livea-quantite')) t.id = 'livea-quantite';
  }

  function goToQty(e) {
    tagTarget();
    var t = qtyTarget();
    if (!t) return;                       // pas de cible : on laisse le clic tel quel
    if (e) e.preventDefault();
    var r = t.getBoundingClientRect();
    var pageTop = r.top + (window.pageYOffset || document.documentElement.scrollTop);
    var top = r.height < window.innerHeight
      ? pageTop - (window.innerHeight - r.height) / 2
      : pageTop - 20;
    t.style.transition = 'box-shadow .4s ease';
    t.style.boxShadow = '0 0 0 3px rgba(20,120,80,.45)';
    setTimeout(function () { t.style.boxShadow = ''; }, 1600);
    animateTo(top, function () {
      var f = t.querySelector('input[name="quantity"], select, button');
      if (f && f.focus) { try { f.focus({ preventScroll: true }); } catch (err) {} }
    });
  }

  // Tout element cliquable d'une section LIVEA renvoie vers la quantite.
  var CTA = 'a, button, [role="button"], .btn, .button, [class*="cta"]';

  function initCta() {
    if (document.__liveaCta) return;
    document.__liveaCta = true;
    tagTarget();
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest(CTA) : null;
      if (!t || !t.closest('.livea-page')) return;
      if (t.closest('.rr-arrow') || t.classList.contains('rr-arrow')) return;  // fleches du carrousel
      if (t.closest('summary') || t.tagName === 'SUMMARY') return;             // accordeons
      var href = t.getAttribute && t.getAttribute('href');
      if (href && !href.startsWith('#') && href !== '') return;                // vrai lien externe
      goToQty(e);
    });
  }

  /* ----------------------------------------------- carrousel des avis */
  function initReviews(root) {
    all('.rr-track', root).forEach(function (track) {
      if (track.__lDone) return;
      track.__lDone = true;
      var cards = all(':scope > .rr-card', track);
      if (cards.length < 2) return;

      track.style.display = 'flex';
      track.style.overflowX = 'auto';
      track.style.scrollSnapType = 'x mandatory';
      track.style.scrollBehavior = 'smooth';
      track.style.scrollbarWidth = 'none';
      cards.forEach(function (c) {
        c.style.flex = '0 0 min(360px, 86%)';
        c.style.scrollSnapAlign = 'center';
      });
      if (!document.getElementById('livea-inline-css')) {
        var st = document.createElement('style');
        st.id = 'livea-inline-css';
        st.textContent = '.livea-page .rr-track::-webkit-scrollbar{display:none}';
        document.head.appendChild(st);
      }

      function index() {
        var mid = track.scrollLeft + track.clientWidth / 2, b = 0, d = Infinity;
        cards.forEach(function (c, k) {
          var cc = c.offsetLeft + c.offsetWidth / 2 - track.offsetLeft;
          if (Math.abs(cc - mid) < d) { d = Math.abs(cc - mid); b = k; }
        });
        return b;
      }
      function go(k) {
        k = Math.max(0, Math.min(cards.length - 1, k));
        track.scrollTo({ left: cards[k].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      var scope = track.closest('.custom') || track.parentNode;
      var arrows = all('.rr-arrow', scope);
      if (arrows[0]) arrows[0].addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(index() - 1); });
      if (arrows[1]) arrows[1].addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(index() + 1); });
    });
  }

  function boot() {
    initCta();
    all('.livea-page').forEach(initReviews);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
